import { render, staticRenderFns } from "./Surveyend.vue?vue&type=template&id=10df919e&"
import script from "./Surveyend.vue?vue&type=script&lang=js&"
export * from "./Surveyend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports